import { ObjectHelpers } from "../../helpers/object-helpers";

export class TradeAccountModel {
    public id = 0;
    public name = '';

    constructor(data?: any) {
        if (data) ObjectHelpers.setProperties(data, this, true);
    }

    public static makeList(accounts: Array<any>): Array<TradeAccountModel> {
        const result: Array<TradeAccountModel> = [];
        if (accounts?.length) {
            for (const acc of accounts) {
                result.push(new TradeAccountModel(acc));
            }
        }
        return result;
    }
}